<template>
  <div>
    <div class="banner">
      <div class="userCon">
        <h1>如何预约心理咨询？如何开启心理咨询？</h1>
        <p>根据医生的开放时间可进行预约，在预约时间内可与医生进行视频咨询</p>
      </div>
    </div>
    <div class="content userCon">
      <div class="left">
        <div class="select flex" @click="active=0" :class="{'active':active===0}">
          <img src="../../assets/img/pc.png" alt="" width="38">
          <strong>电脑端</strong>
        </div>
        <div class="select flex" @click="active=1" :class="{'active':active===1}">
          <img src="../../assets/img/mobilePhone.png" alt="" width="38">
          <strong>手机端</strong>
        </div>
      </div>
      <div class="right">
        <template v-if="active==0">
          <p><strong>第一步：</strong>登录状态下，点击顶部菜单栏中的<span class="orange">【专业医生】</span>或<span class="orange">【我要咨询】</span>
          </p>
          <img src="../../assets/img/userAppoint_a.png" alt="">
          <p><strong>第二步：</strong>① 在【专业医生】页面，点击可预约医生的<span class="orange">【主页】</span>按钮，在【医生主页】中点击<span class="orange">【我要咨询】</span>按钮，进入预约页面
          </p>
          <img src="../../assets/img/userAppoint_b.png" alt="" width="900">
          <p>② 在【我要咨询】页面，点击<span class="orange">【预约】</span>按钮，进入预约页面</p>
          <img src="../../assets/img/userAppoint_c.png" alt="" width="900">
          <p><strong>第三步：</strong>① 在【预约】页面，先在【可预约时间表】中选择预约时间，按照提示填写预约信息<br/>
            ② 仔细阅读<span class="orange">【《心理亦笙》咨询预约协议】</span>，如您没有异议请勾选：√我已阅读并同意<br/>
            ③ 点击<span class="orange">【提交预约】</span>按钮，进入【支付页面】<br/>
          </p>
          <img src="../../assets/img/userAppoint_d.png" alt="">
          <p><strong>第四步：</strong>在【支付页面】，确认预约信息，选择支付方式，目前仅支持【微信支付】，点击<span class="orange">【立即支付】</span>按钮，显示出【微信二维码】，
            请使用微信扫一扫功能进行支付，支付完成，即预约完成
          </p>
          <img src="../../assets/img/userAppoint_e.png" alt="" width="911">
          <p><strong>第五步：</strong>① 登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【我的预约】</span>按钮，进入【预约列表页面】<br/>
            ② 找到即将咨询的预约条目，点击<span class="orange">【去咨询】</span>按钮，进入【通话页面】
          </p>
          <img src="../../assets/img/userAppoint_f.png" alt="" width="906">
          <p><strong>第六步：</strong>在【通话】页面，请耐心等待医生呼叫，医生呼叫时会出现【邀请通话】弹窗，点击<span class="orange">【接听】</span>图标接收通话
          </p>
          <img src="../../assets/img/userAppoint_g.png" alt="">
        </template>
        <template v-else>
          <div class="flex userPh">
            <p><strong>第一步：</strong>登录状态下，在【首页】，点击<span class="orange">【我要咨询】</span>按钮，进入【医生列表页面】</p>
            <p><strong>第二步：</strong>在【医生列表】中，点击要进行咨询预约的医生条目，进入【医生主页】</p>
            <p><strong>第三步：</strong>在【医生主页】，选择预约时间，并点击<span class="orange">【我要预约】</span>按钮</p>
          </div>
          <img src="../../assets/img/userAppointRes_a.png" alt="">
          <div class="flex userPh">
            <p><strong>第四步：</strong>按照提示填写相关信息，点击<span class="orange">【提交预约】</span>按钮</p>
            <p><strong>第五步：</strong>在支付页面选择【微信支付】，点击<span class="orange">【我要支付】</span>按钮</p>
            <p><strong>第六步：</strong>在微信中点击<span class="orange">【确认支付】</span>，完成预约</p>
          </div>
          <img src="../../assets/img/userAppointRes_b.png" alt="">
          <p class="orange">【注】当完成支付时，优惠金额大于等于支付金额时，点击【提交预约】，即可完成预约 </p>
          <div class="flex userPh mt_20">
            <p><strong>第七步：</strong>在【菜单栏】中<span class="orange">【我的预约】</span>按钮</p>
            <p><strong>第八步：</strong>在【预约列表】中点击<span class="orange">【去咨询】</span></p>
            <p><strong>第九步：</strong>使用【微信APP】，识别<span class="orange">【心理亦笙】</span>小程序二维码</p>
          </div>
          <img src="../../assets/img/userAppointRes_c.png" alt="">
          <div class="flex userPh mt_20">
            <p><strong>第十步：</strong>进入【亦笙工作室】微信小程序中，填写登录信息，点击<span class="orange">【登录】</span>按钮</p>
            <p><strong>第十一步：</strong>在【待通话列表】中，点击<span class="orange">【通话】</span>按钮，进入通话页面</p>
            <p><strong>【医生未就绪状态】：</strong>请耐心等待医生呼叫</p>
          </div>
          <img src="../../assets/img/userAppointRes_d.png" alt="">
          <p><strong>【通话状态】</strong></p>
          <div class="flex" >
            <img src="../../assets/img/userAppointRes_e.png" alt="" width="34%">
            <div class="mt_50">
              <div class="mt_20">【视频通话】<br/>进入咨询等待页面后，请耐心等待用户的应答</div>
              <div class="mt_20">【文字聊天】<br/>视频下方有文字聊天框，可发送图片，协助咨询交流</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "userAppoint",
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    $(".contentIndex").animate({scrollTop: '0px'}, 800);
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/userRegister';
</style>
